import './PlaceItem.scss'

import SvgPdsMarkerIcon from 'components/Map/components/SvgPdsMarkerIcon' // TODO move this component to another layer
import { TripAdvisorRating } from 'components/TripAdvisorRating'
import { PageType, useNavigation } from 'lib/hooks'
import React from 'react'

export interface PlaceItemProps {
  pdsUrl: string
  name: string
  address: string
  rating?: number
  reviewCount?: number
  categoryId?: string
  imageUrl?: string
  distanceFromPoint?: string
}

const PlaceItem = ({
  pdsUrl,
  name,
  address,
  rating,
  reviewCount,
  distanceFromPoint,
  imageUrl,
  categoryId,
}: PlaceItemProps): JSX.Element => {
  const { goTo } = useNavigation()
  const handleLinkClick = (): void => {
    goTo({ type: PageType.PDC, url: pdsUrl })
  }

  return (
    <div className="PlaceItem" onClick={handleLinkClick}>
      {imageUrl !== undefined ? (
        <img src={imageUrl} className="PlaceItem__thumbnail" />
      ) : (
        <div className="PlaceItem__icon">
          <SvgPdsMarkerIcon
            isStared={true}
            categoryId={categoryId}
            isSelected={true}
            innerColor="white"
          />
        </div>
      )}
      <div className="PlaceItem__content">
        <div className="PlaceItem__title">{name}</div>
        <div className="PlaceItem__subtitle">
          {distanceFromPoint !== undefined && (
            <span className="PlaceItem__distance">{distanceFromPoint}</span>
          )}
          <span className="PlaceItem__address">{address}</span>
        </div>
        {rating !== undefined && reviewCount !== undefined ? (
          <div className="PlaceItem__rating">
            <TripAdvisorRating value={rating} reviewCount={reviewCount} />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default PlaceItem
